export const returnAllImg = list => {
  if (list.length === 0) return [];
  list.forEach(el => {
    const leftData = JSON.parse(el.leftNavStr);
    el.AllImage = [];
    leftData.forEach(e => {
      el.AllImage = [...el.AllImage, ...e.imgList];
    });
  });
  return list;
};
export const randomLenNum = (len, date) => {
  let random = "";
  random = Math.ceil(Math.random() * 100000000000000)
    .toString()
    .substr(0, len || 4);
  if (date) random = random + Date.now();
  return random;
};

export const CheckInput = (type, value) => {
  const idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/; //   身份证
  const telReg = /^1[3456789]\d{9}$/; //   手机号
  const emailReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/; //   邮箱
  const bankReg = /^([1-9]{1})(\d{15}|\d{18})$/; //    银行卡
  const qyReg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g; //   企业信用代码
  switch (type) {
    case "idcardReg":
      return idcardReg.test(value);
    case "telReg":
      return telReg.test(value);
    case "emailReg":
      return emailReg.test(value);
    case "bankReg":
      return bankReg.test(value);
    case "qyReg":
      return qyReg.test(value);
  }
};

export const GetImgRaio = src => {
  return new Promise((resolve, reject) => {
    if (src.toUpperCase().endsWith(".DWG")) {
      resolve();
      return;
    }
    let imgObj = new Image();
    imgObj.src = src;
    imgObj.onload = function() {
      let imgBL = null;
      let domWidth = null;
      let imgRaio = null;
      if (imgObj.width > imgObj.height) {
        // 横图  560
        imgBL = 560 / imgObj.width;
        let domWidth = imgObj.width * imgBL;
        imgRaio = parseFloat(domWidth / 480);
      } else {
        // 竖图 537
        imgBL = 537 / imgObj.height;
        domWidth = imgObj.width * imgBL;
        imgRaio = parseFloat(domWidth / 480);
      }
      const imgdata = {
        width: imgObj.width,
        height: imgObj.height,
        imgRaio: parseFloat(imgBL).toFixed(2),
        dragRaio: parseFloat(imgRaio).toFixed(2)
      };
      resolve(imgdata);
    };
  });
};

export const DownloadByA = (url, fileName) => {
  let Adom = document.createElement("a");
  Adom.href = url;
  Adom.download = fileName;
  document.body.appendChild(Adom);
  Adom.click();
  document.body.removeChild(Adom);
};

export const formatMoney = (value) => {
  if (isBlank(value)) {
    return '0.00';
  }
  try {
    value = parseFloat(value).toFixed(2);
    let m = value.toString().split('.');
    return (m[0] || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + m[1];
  } catch (e) {
    return '0.00';
  }
};
export const isBlank = _str => {
  if (_str === null || _str === '' || _str === undefined || _str.length === 0 || _str === {}) return true;
};



// WEBPACK FOOTER //
// ./src/utils/Tools.js